import React from 'react'
import PropTypes from 'prop-types'
import Map from './map'
// FIXME: change to GoogleMapRenderer
const RendererWithGoogleMap = (props) => {
  const {
    containerElement,
    mapElement,
    loadingElement,
    onMapLoad,
    onMapClick,
    markers,
    defaultCenter,
    onMarkerRightClick,
    zoom,
    markerIcon,
    googleMapApiKey,
    googleMapUrl,
    onPositionChanged,
    getPosition,
    setlocation,
    center,
    setcentermap,
    refs
  } = props
  return (
    <Map
      setlocation={setlocation.bind(this)}
      loadingElement={loadingElement}
      containerElement={
        containerElement
      }
      mapElement={
        mapElement
      }
      onMapLoad={onMapLoad}
      onMapClick={onMapClick}
      markers={markers}
      defaultCenter={defaultCenter}
      onMarkerRightClick={onMarkerRightClick}
      zoom={zoom}
      markerIcon={markerIcon}
      center={center}
      setcentermap={setcentermap.bind(this)}
      disableDefaultUI={true}
      streetViewControl={false}
    />
  )
}

RendererWithGoogleMap.propTypes = {
  containerElement: PropTypes.node,
  loadingElement: PropTypes.node,
  mapElement: PropTypes.node,
  onMapLoad: PropTypes.func,
  onMapClick: PropTypes.func,
  onMarkerRightClick: PropTypes.func,
  markers: PropTypes.array,
  defaultCenter: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  zoom: PropTypes.number,
  markerIcon: PropTypes.string,
  //googleMapApiKey: PropTypes.string,
  //googleMapUrl: PropTypes.string,
}

RendererWithGoogleMap.defaultProps = {
  loadingElement: <div />,
  onMapLoad: () => {},
  onMapClick: (e) => {
      // console.log("LAT",e.latLng.lat(),"LONG",e.latLng.lng())
    },
  onMarkerRightClick: PropTypes.func.isRequired,
  markers: [],
  defaultCenter: {
    lat: 0,
    lng: 0,
  },
  zoom: 12,
  markerIcon: undefined,
  //googleMapApiKey: '',
  //googleMapUrl: '',
}

export default RendererWithGoogleMap



// WEBPACK FOOTER //
// ./src/components/google_map.js